import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import parseISO from 'date-fns/parseISO';
import { fr, enUS, de, es } from 'date-fns/locale';

import { ENGLISH, FRENCH, GERMAN, SPANISH } from './constants/language_region_codes';

const localeMap = {};
localeMap[ENGLISH] = enUS;
localeMap[FRENCH] = fr;
localeMap[GERMAN] = de;
localeMap[SPANISH] = es;

const monthDayYear = (date, locale = ENGLISH, longMonth = true) => {
  return new Date(date).toLocaleDateString(locale, {
    month: longMonth ? 'long' : 'short',
    day: 'numeric',
    year: 'numeric'
  });
};

const formattedDate = (date, timezoneId, languageRegionCode = ENGLISH) => {
  if (timezoneId) {
    return date.toLocaleDateString(languageRegionCode, {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: timezoneId,
      timeZoneName: 'short'
    });
  }
  return date.toLocaleDateString(languageRegionCode, { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
};

const dateString = (date = new Date(), timezone = null, languageRegionCode = ENGLISH) => {
  return timezone
    ? new Date(date).toLocaleDateString(languageRegionCode, {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        timeZone: timezone,
        timeZoneName: 'short'
      })
    : new Date(date).toLocaleDateString(languageRegionCode, {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      });
};

const daysAgoInSeconds = days => {
  const d = new Date();
  d.setDate(d.getDate() - days);
  return d / 1000; // ms -> s
};

const localizedFormat = (abbreviate = false, locale = ENGLISH, withTime = false) => {
  let result;
  switch (locale) {
    case ENGLISH:
      result = abbreviate ? 'MMM. dd, yyyy' : 'MMMM dd, yyyy';
      break;
    case GERMAN:
      result =  abbreviate ? 'dd. MMM. yyyy' : 'dd. MMMM yyyy';
      break;
    case FRENCH:
      result =  abbreviate ? 'dd MMM yyyy' : 'dd MMMM yyyy';
      break;
    case SPANISH:
      result =  abbreviate ? "dd 'de' MMM. 'de' yyyy" : "dd 'de' MMMM 'de' yyyy";
      break;
    default:
      result =  abbreviate ? 'MMM dd, yyyy' : 'MMMM dd, yyyy';
  }
  if (withTime) {
    switch (locale) {
      case ENGLISH:
        result = `${result} hh:mm a z`;
        break;
      default:
        result = `${result} HH:mm`;
    }
  }
  return result;
};

const isToday = potentialDate => {
  const date = new Date(potentialDate);
  const today = new Date();

  return date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() && today.getFullYear();
};

const timeAgo = (dateStr, languageRegionCode) => {
  const date = parseISO(dateStr);
  const options = { addSuffix: true, locale: localeMap[languageRegionCode] };
  return formatDistanceToNow(date, options);
};

const parseTimeString = time => {
  return parseInt(time.split(':')[0]);
};

const betweenHours = (start, end) => {
  const [startHour, endHour] = [parseTimeString(start), parseTimeString(end)];
  const currentHour = new Date().getHours();

  // this would be that the time goes from late PM to early AM
  if (startHour >= endHour) {
    return currentHour >= startHour;
  }

  return currentHour >= startHour && currentHour <= endHour;
};

export { localeMap, formattedDate, monthDayYear, daysAgoInSeconds, dateString, localizedFormat, isToday, timeAgo, betweenHours };
